function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import _ from 'lodash';
var hasDocument = (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document !== null;
var hasWindow = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window !== null && window.self === window;

// eslint-disable-next-line no-confusing-arrow
var _isBrowser = function isBrowser() {
  return !_.isNil(_isBrowser.override) ? _isBrowser.override : hasDocument && hasWindow;
};
export default _isBrowser;
//# sourceMappingURL=isBrowser.js.map